module.exports = __webpack_public_path__ + "static/media/Gestion-ESTRATEGICA.48ca5c6b.svg";